import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import PlaceComponent from "./components/place.component";
import Locations from "./Locations";
import ProductSearch from "./components/ProductSearch";
import { Provider, ErrorBoundary, LEVEL_WARN } from '@rollbar/react'; // Provider imports 'rollbar'

// move to hosted version on s3 or npoint? https://www.npoint.io/
// import deliveryStores from './data/delivery_stores.json';
// import deliveryStates from './data/delivery_states.json';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Helper function to get shopper location from cookies
function getShopperLocationFromCookies() {
  const savedLocation = cookies.get('shopperLocation');
  if (savedLocation && savedLocation.city && savedLocation.state && savedLocation.lat && savedLocation.lng) {
    return {
      city: savedLocation.city, 
      state: savedLocation.state, 
      lat: savedLocation.lat, 
      lng: savedLocation.lng
    };
  }
  return null;
}

const rollbarConfig = {
  accessToken: '085577f54cac4a318dbe1695519dcde3',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  server: {
    code_version: process.env.REACT_APP_VERSION || require('../package.json').version
  },
  enabled: ('production' === process.env.NODE_ENV)
};

const ErrorDisplay = ({ error, resetError }) => ( // <-- props passed to fallbackUI component
  <div>
    <h2>Oops!</h2>
    <p>Something went wrong. We've been alerted.</p>
    <p><button onClick={() => window.location.reload(false)}>Click to reload!</button></p>
    <p className="tiny">Error tracking {rollbarConfig.enabled ? 'enabled' : 'disabled'}</p>
  </div>
);


function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

function parseJSON(response) {
  return response.json()
}

class StoreSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shopperLocation: null,  // make this always just what you need, like {city, state}, not the entire object
      showDeliveryOptions: true, // Show delivery options when available
      activeTab: 'stores',
    };

    // to reset cookie uncomment
    // cookies.remove('shopperLocation');
    // cookies.remove('pickupOrDelivery');
    // console.log('Loading fromm cookie: ');
    // console.log(location);

    // load showDeliveryOptions from cookies, or save to cookies
    let showDeliveryOptions = cookies.get('showDeliveryOptions');
    if (showDeliveryOptions !== undefined) {
      this.state.showDeliveryOptions = showDeliveryOptions === 'true';
    } else {
      cookies.set('showDeliveryOptions', this.state.showDeliveryOptions, { path: '/' });
    }

    // load pickupOrDelivery from cookies, or load from storerocket and save to cookies
    let shopperLocation = cookies.get('shopperLocation');
    if (shopperLocation && shopperLocation.city && shopperLocation.state && shopperLocation.lat && shopperLocation.lng) {  // TODO: sanitize the cookie, make sure it's real
      this.state.shopperLocation = {city: shopperLocation.city, state: shopperLocation.state, lat: shopperLocation.lat, lng: shopperLocation.lng};
      this.refreshState();
    } else {  // use storerocket to get the default one
      let that = this;
      fetch('https://storerocket.io/api/location')
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          if (process.env.NODE_ENV === 'development') {
            console.log('request succeeded with JSON response', data);
          }
  
          shopperLocation = {city: data.city, state: data.state, lat: data.lat, lng: data.lon};
          that.setState({
            shopperLocation: shopperLocation,
          }, that.refreshState);
          if (process.env.NODE_ENV === 'development') {
            console.log('Setting cookie from Store Rocket');
          }
        }).catch(function(error) {
          console.error('request failed', error)
      });
    }
  }

  componentDidMount() { 
    this._ismounted = true;
  }
  
  componentWillUnmount() {
     this._ismounted = false;
  }

  refreshState = () => {
    cookies.set('shopperLocation', this.state.shopperLocation, { path: '/' });
    cookies.set('showDeliveryOptions', this.state.showDeliveryOptions, { path: '/' });
  };

  handlePlaceChanged = (current) => {
    const place = current.getPlace();
    if (place) {
      // console.log(place.address_components);

      let [city, state] = this.extractCityState(place.address_components);
      if (process.env.NODE_ENV === 'development') {
        console.log('Setting cookie from Google Autocomplete');
      }
      
      this.setState({
        shopperLocation: {
          city: city,
          state: state,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        },
      }, this.refreshState);

      if (process.env.NODE_ENV === 'development') {
        console.log(this.state.shopperLocation);
      }
      // console.log(place.geometry.location.lat())
      // console.log(place.geometry.location.lng())
    }
  };

  extractCityState = (address_components) => {
    let city = null;
    let state = null;

    address_components.forEach(element => {
      let index = element['types'].indexOf('locality');
      if (index >= 0) {
        city = element['long_name'];
      }
      index = element['types'].indexOf('administrative_area_level_1');
      if (index >= 0) {
        state = element['short_name'];
      }
    });
    return [city, state];
  };

  storesSelected = () => {
    this.setState({
      activeTab: 'stores',
    }, this.refreshState);
  };

  productSearchSelected = () => {
    this.setState({
      activeTab: 'product-search',
    });
  };

  render() {
    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay}>
          <div className="store-selector">
            <div className="main-tabs">
              <button 
                className={this.state.activeTab === 'stores' ? 'active-class' : ''} 
                onClick={this.storesSelected}
              >
                Find Stores
              </button>
              <button 
                className={this.state.activeTab === 'product-search' ? 'active-class' : ''} 
                onClick={this.productSearchSelected}
              >
                Product Search
              </button>
            </div>
            <br/>
            <div className="auto-complete">
              <PlaceComponent placeholder={this.state.shopperLocation} handlePlaceChanged={this.handlePlaceChanged}/>
            </div>
            
            {this.state.activeTab === 'product-search' ? (
              <ProductSearch shopperLocation={this.state.shopperLocation} />
            ) : (
              <Locations 
                shopperLocation={this.state.shopperLocation}
                showDeliveryOptions={this.state.showDeliveryOptions}
                integrated={true}
                limit={(getConfig().limit === null || getConfig().limit === "null" || getConfig().limit === undefined) ? null : parseInt(getConfig().limit)}
                infiniteScroll={getConfig().infiniteScroll === true}
              />
            )}
          </div>
          <p className="tiny">{process.env.NODE_ENV} - v{rollbarConfig.server.code_version}</p>
        </ErrorBoundary>
      </Provider>
    );
  }
}


// ========================================

// Get configuration from window object
function getConfig() {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined' && window.STORE_LOCATOR_CONFIG) {
    return window.STORE_LOCATOR_CONFIG;
  }
  return {};
}

// Determine which view to render based on config or URL parameter
function getViewMode() {
  const config = getConfig();
  
  // First check config
  if (config.view) {
    return config.view;
  }
  
  // Then check URL parameter
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('view') || 'full';
  }
  
  return 'full'; // Default to full view
}

const viewMode = getViewMode();
const config = getConfig();
const root = ReactDOM.createRoot(document.getElementById("root"));

// Log configuration to help with debugging only in development
if (process.env.NODE_ENV === 'development') {
  console.log('Root config:', config);
  console.log('View mode:', viewMode);
  console.log('stockOnly setting:', config.stockOnly);
  console.log('limit setting:', config.limit);
  console.log('infiniteScroll setting:', config.infiniteScroll);
}

// Render the appropriate component based on view mode
if (viewMode === 'stores-only') {
  const stockOnly = config.stockOnly === true;
  // Normalize limit - handle string "null" and convert to actual null
  const limit = (config.limit === null || config.limit === "null" || config.limit === undefined) 
    ? null 
    : parseInt(config.limit);
  const infiniteScroll = config.infiniteScroll === true;
  
  // Try to get location from cookies, with fallback to StoreRocket API
  let shopperLocation = getShopperLocationFromCookies();
  
  // Force geolocation test if ?testGeo=true is in URL
  const urlParams = new URLSearchParams(window.location.search);
  const forceGeoTest = urlParams.get('testGeo') === 'true';
  
  // If no location in cookies OR forcing geo test, fetch from StoreRocket API
  if (!shopperLocation || forceGeoTest) {
    fetch('https://storerocket.io/api/location')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        // Validate required fields
        if (!data.city || !data.state || !data.lat || !data.lon) {
          throw new Error('Invalid geolocation data received');
        }
        
        const newLocation = {
          city: data.city, 
          state: data.state, 
          lat: data.lat, 
          lng: data.lon
        };
        cookies.set('shopperLocation', newLocation, { path: '/' });
        // Reload to use the new location
        window.location.reload();
      })
      .catch(error => {
        console.error('StoreRocket geolocation failed:', error);
        // Fallback to default location (Massachusetts) if geolocation fails
        const fallbackLocation = {
          city: 'Boston',
          state: 'MA', 
          lat: 42.3601,
          lng: -71.0589
        };
        cookies.set('shopperLocation', fallbackLocation, { path: '/' });
        if (process.env.NODE_ENV === 'development') {
          console.warn('Using fallback location due to geolocation failure');
        }
        window.location.reload();
      });
  }
  
  // Determine whether to show delivery options
  const showDeliveryOptions = config.showDeliveryOptions !== false;

  root.render(
    <Provider config={rollbarConfig}>
      <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay}>
        <div className="store-selector store-only-view">
          <div className="auto-complete">
            <PlaceComponent 
              placeholder={shopperLocation} 
              handlePlaceChanged={(current) => {
                const place = current.getPlace();
                if (place) {
                  // Extract city/state and save to cookies
                  let city = null;
                  let state = null;
                  
                  place.address_components.forEach(element => {
                    if (element.types.includes('locality')) {
                      city = element.long_name;
                    }
                    if (element.types.includes('administrative_area_level_1')) {
                      state = element.short_name;
                    }
                  });
                  
                  const newLocation = {
                    city: city,
                    state: state,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                  };
                  
                  cookies.set('shopperLocation', newLocation, { path: '/' });
                  window.location.reload(); // Reload to use the new location
                }
              }}
            />
          </div>
          <Locations 
            shopperLocation={shopperLocation}
            stockOnly={stockOnly}
            showDeliveryOptions={showDeliveryOptions}
            integrated={true}
            limit={limit}
            infiniteScroll={infiniteScroll}
          />
          <p className="tiny">{process.env.NODE_ENV} - v{rollbarConfig.server.code_version}</p>
        </div>
      </ErrorBoundary>
    </Provider>
  );
} else {
  // Default to the full StoreSelector
  root.render(<StoreSelector />);
}